import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RedirectComponent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const entity_id = params.get("entity_id");
    const batch_id = params.get("batch_id");

    const redirectUrl = `https://old.transparent.utah.gov/batch_summary.php?entity_id=${entity_id ?? ""}&batch_id=${batch_id ?? ""}`;
    console.log(`Redirecting to: ${redirectUrl}. Current Entity ID: ${entity_id}, Batch ID: ${batch_id}`);

    window.location.replace(redirectUrl);
  }, [location]);

  return null;
};

export default RedirectComponent;
